import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { UserModel } from '../../models/user/userModel';
import { Link } from "react-router-dom";
import * as HelperFunctions from "../../common/functions/helperFunctions";
import AuthService from '../../services/authService';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import Growl from '../../common/components/alertMessage/growl';
import { FBUserModel } from '../../models/fbUserModel';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPills } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import { string } from "prop-types";

interface IProps {
  history: any,
  onUserLogin: any
}

interface IState {
  isLoading: boolean;
  user: UserModel;
  isLogged: boolean;
  fbUser: FBUserModel;
}

class LoginComponent extends React.Component<IProps, IState> {

  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      user: new UserModel(),
      isLogged: false,
      fbUser: new FBUserModel()
    };
  }

  componentDidMount() {
  }

  handleChange = (key, value) => {
    const user: UserModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  handleCreateNewAccount = () => {
    this.props.history.push(`/create-new-account`);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLoginButton(e);
    }
  }

  isValidAddEditForm() {
    let message = '';

    if (!this.state.user.email || this.state.user.email.trim() == '') {
      message += Translate('Please enter Email') + '. ';
    } else {
      if (!HelperFunctions.validateEmail(this.state.user.email.trim())) {
        message += Translate('Please enter valid Email') + '. ';
      }
    }

    if (!this.state.user.password || this.state.user.password.trim() == '') {
      message += Translate('Please enter Password') + '. ';
    }

    if (message != '') {
      this.growl.show({ severity: 'error', summary: message });
    }

    return message == '';
  }

  handleLoginButton = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const user = this.state.user;

    this.authService.login(user.email, user.password).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            isLogged: data
          });
          this.redirectAfterLogin();
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  redirectAfterLogin() {
    this.props.onUserLogin();

    let returnUrlParam = HelperFunctions.getURLParameter('returnUrl');

    if (returnUrlParam) {
      let returnUrl = decodeURI(returnUrlParam + '');
      this.props.history.push(returnUrl);
      //window.location.href = returnUrl;
    } else {
      this.props.history.push(`/user/dashboard`);
    }
  }

  handleFacebookResponse = (response) => {

    this.setState({
      isLoading: true
    });

    if (response.status === 'unknown') {
      this.setState({
        isLoading: false
      });

      return;
    }

    this.authService.facebookLogin(response.accessToken).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            isLogged: data
          });
          this.redirectAfterLogin();
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleGoogleResponse = (response) => {

    this.setState({
      isLoading: true
    });

    this.authService.googleLogin(response.tokenId, response.googleId).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            isLogged: data
          });
          this.redirectAfterLogin();
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleGoogleFailureResponse = (response) => {
    // console.log(response);
  }

  public render() {
    const { isLoading, user, fbUser } = this.state;

    return (
      <div className="app-content">
        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h2>{Translate('Login')}</h2>

        <div>
          <div className="p-g p-fluid">
            <div className="p-g-12 p-md-6">
              <TextField
                name="email"
                label={Translate('Email')}
                type="email"
                value={user && user.email ? user.email : ""}
                onChange={(e) => this.handleChange('email', e.target['value'])}
              />
            </div>
            <div className="p-g-12 p-md-6">
              <TextField
                type="password"
                name="password"
                label={Translate('Password')}
                onKeyPress={this.handleKeyPress}
                onChange={(e) => this.handleChange('password', e.target['value'])}
                value={user && user.password ? user.password : ""}
              />
              <div style={{ textAlign: 'right', padding: '5px 0' }}>
                <Link to='/forgot-password'>{Translate('Forgot password?')}</Link>
              </div>
            </div>

            <div className="p-g-12 p-md-6">

              <Button variant="contained" size="medium" color='primary' onClick={this.handleLoginButton}
                style={{ width: '100%', marginBottom: '15px' }}>
                {Translate('Login')}
              </Button>

              <div className="break-wrap">
                <div className="break-text">
                  {Translate("New to MedXchange?")}
                </div>
              </div>

              <Button variant="contained" size="medium" onClick={this.handleCreateNewAccount} style={{ width: '100%' }}>
                {Translate('Create a New Account')}
              </Button>

              <div className="break-wrap">
                <div className="break-text">
                  {Translate("or login with")}:
                </div>
              </div>

              <div className="socialNetworks">

                <div className="facebook-wrap">
                  <FacebookLogin
                    appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                    autoLoad={false}
                    fields="name,email"
                    callback={this.handleFacebookResponse}
                    cssClass="facebook-button-class"
                    textButton=""
                    icon="fa-facebook"
                  />
                </div>
                <div className="google-wrap">
                  <GoogleLogin
                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}
                    render={(renderProps: any) => (
                      <button onClick={renderProps.onClick} className="google-button-class">
                        <FontAwesomeIcon icon={faGoogle} />
                      </button>
                    )}
                    buttonText="Login"
                    onSuccess={this.handleGoogleResponse}
                    onFailure={this.handleGoogleFailureResponse}
                  />
                </div>
              </div>
            </div>
          </div>


          {/* <div className="socialNetworks">

            <div className="sign-in-or">
              {Translate("or sign in with")}:
            </div>

            <div className="facebook-wrap">
              <FacebookLogin
                appId="1139665549525274"
                autoLoad={true}
                fields="name,email"
                onClick={() => console.log('onCclick')}
                callback={this.handleFacebookResponse}
                cssClass="facebook-button-class"
                textButton=""
                icon="fa-facebook"
              />
            </div>

            <div className="google-wrap">
              <GoogleLogin
                clientId="420458124043-58g91e9epre78l64smvlj2vajc88elga.apps.googleusercontent.com"
                render={renderProps => (
                  <button onClick={() => renderProps ? renderProps.onClick : null} className="google-button-class">
                    <FontAwesomeIcon icon={faGoogle} />
                  </button>
                )}
                buttonText="Login"
                onSuccess={this.handleGoogleResponse}
                onFailure={this.handleGoogleResponse}
              />

            </div>

          </div> */}


          {/* <br /><br />
          <a href="#" onClick={(e) => { e.preventDefault(); window['FB'].logout() }}>Facebook logout</a>
          <br /><br /> */}

          {/* <div>
            FB: <br />
            {fbUser && fbUser.name ? 'Name: ' + fbUser.name : null} <br />
            {fbUser && fbUser.email ? 'Email: ' + fbUser.email : null} <br />
          </div> */}

          {/* <br /><br />
              <GoogleLogout
                buttonText="Logout"
                onLogoutSuccess={() => console.log('logout')}
              />*/}

        </div>

      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogin: () => dispatch({ type: actionTypes.USER_LOGIN })
  }
}

export default connect(null, mapDispatchToProps)(LoginComponent);